import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { colourThemeType } from '../../propTypes';
import { getSliceColourTheme, sliceHasCategories } from '../../selectors';
import { sliceColourTheme } from '../../styles/theme';
import Categories from '../Categories';
import TrayModule from '../TrayModule';
import TrayToolbar from '../TrayToolbar';
import JobBoard from './JobBoard';

const GreenhouseTray = ({
  className, hasCategories, colourTheme, sliceId, sliceType,
}) => (
  <TrayModule
    className={className}
    colourTheme={colourTheme}
    sliceId={sliceId}
    sliceType={sliceType}
  >
    <TrayToolbar colourTheme={colourTheme} sliceId={sliceId}>
      {hasCategories && <Categories />}
    </TrayToolbar>

    <JobBoard colourTheme={colourTheme} />
  </TrayModule>
);

GreenhouseTray.propTypes = {
  className: PropTypes.string,
  hasCategories: PropTypes.bool,
  colourTheme: colourThemeType,
  sliceId: PropTypes.number.isRequired,
  sliceType: PropTypes.string,
};

GreenhouseTray.defaultProps = {
  className: undefined,
  hasCategories: false,
  sliceType: undefined,
  colourTheme: sliceColourTheme.white,
};

const mapStateToProps = (state, { sliceId }) => ({
  hasCategories: sliceHasCategories(state, sliceId),
  colourTheme: sliceColourTheme[getSliceColourTheme(state, sliceId)],
});

export default connect(mapStateToProps)(GreenhouseTray);
